export const ProductsData = [
  //Histeria Max Chocolate
  {
    Images: [
      "/images/Product1/HisteriaMaxEaten.webp",
      "/images/Product1/HisteriaMax1.webp",
      "/images/Product1/HisteriaMax2.webp",
      "/images/Product1/HisteriaMax3.webp",
    ],

    title: "Histeria Max Chocolate",
    description: "بسكويت محشي كريمة الشوكولا المغطس بالشوكولا",
    ingredients:
      "سكر - زيوت نباتية مهدرجة - دقيق القمح - جلوكوز - بودرة الكاكاو - كتلة الكاكاو - حليب خالي الدسم - حليب كامل الدسم - مصل الحليب - ديكستروز - ليستين الصويا E322 (مستحلب) - مواد رافعة (بيروفوسفات الصوديوم E450-1 - بيكربونات الأمونيوم - بيكربونات الصوديوم) - ملح الطعام - منكهات مماثلة للطبيعة.",
    weight: "30 غرام",
    packing: "12 علبة / طرد",
    box: "12 قطعة / علبة",
  },

  //Hugy Moosh Chocolate
  {
    Images: [
      "/images/Product2/HugyMooshDarkEaten.webp",
      "/images/Product2/HugyMooshDark1.webp",
      "/images/Product2/HugyMooshDark2.webp",
      "/images/Product2/HugyMooshDark3.webp",
    ],
    title: "Hugy Moosh Chocolate",
    description: "كيك الشوكولا مع المارشميللو المغطس بالشوكولا",
    ingredients:
      "سكر - زيوت نباتية مهدرجة – مياه – دقيق الطحين – جلوكوز – كاكاو طبيعي – كتلة الكاكاو – بيض - حليب خالي الدسم - حليب كامل الدسم - مصل الحليب – سوربيتول – جيلاتين بقري – نشاء معدل – ديكستروز – ليستين الصويا E322 – غلسرين – كيك جيل – بيروفوسفات الصوديوم – بيكربونات الصوديوم – ملح الطعام – نكهة فانيل – نكهة حليب – نكهة الزبدة – سوربات بوتاسيوم – بروبلين جليكول.",
    weight: "30 غرام",
    packing: "12 علبة / طرد",
    box: "12 قطعة / علبة",
  },

  //Hugy Moosh Milk
  {
    Images: [
      "/images/Product3/HugyMooshWhiteEaten.webp",
      "/images/Product3/HugyMooshWhite1.webp",
      "/images/Product3/HugyMooshWhite2.webp",
      "/images/Product3/HugyMooshWhite3.webp",
    ],
    title: "Hugy Moosh Milk",
    description: "كيك الحليب مع المارشميللو المغطس بالشوكولا",
    ingredients:
      "سكر - زيوت نباتية مهدرجة – مياه – دقيق الطحين – جلوكوز – كاكاو طبيعي – كتلة الكاكاو – بيض - حليب خالي الدسم - حليب كامل الدسم - مصل الحليب – سوربيتول – جيلاتين بقري – نشاء معدل – ديكستروز – ليستين الصويا E322 – غلسرين – كيك جيل – بيروفوسفات الصوديوم – بيكربونات الصوديوم – ملح الطعام – نكهة فانيل – نكهة حليب – نكهة الزبدة – سوربات بوتاسيوم – بروبلين جليكول.",
    weight: "30 غرام",
    packing: "12 علبة / طرد",
    box: "12 قطعة / علبة",
  },

  //Opaliz
  {
    Images: [
      "/images/Product4/OpalizEaten.webp",
      "/images/Product4/Opaliz1.webp",
      "/images/Product4/Opaliz2.webp",
      "/images/Product4/Opaliz3.webp",
    ],
    title: "Opaliz",
    description: "بسكويت مع الكراميل المغطس بالشوكولا",
    ingredients:
      "سكر - زيوت نباتية مهدرجة – دقيق الطحين – جلوكوز – بودرة الكاكاو – كتلة الكاكاو – حليب خالي الدسم – حليب كامل الدسم – مصل الحليب – جيلاتين بقري – ليستين الصويا E322 (مستحلب) – غليسرين – دكستروز – نشاء معدل – مواد رافعة (بيروفوسفات الصوديوم E450-l ، بيكربونات الصوديوم ، بيكربونات الأمونيوم) – حمض الليمون – ملح الطعام – منكهات مماثلة للطبيعة.",
    weight: "28 غرام",
    packing: "12 علبة / طرد",
    box: "12 قطعة / علبة",
  },

  //Histeria Max Milk
  {
    Images: [
      "/images/Product5/HisteriaMaxWhiteEaten.webp",
      "/images/Product5/HisteriaMaxWhite1.webp",
      "/images/Product5/HisteriaMaxWhite2.webp",
      "/images/Product5/HisteriaMaxWhite3.webp",
    ],
    title: "Histeria Max Milk",
    description: "بسكويت محشي كريم الحليب المغطس بالشوكولا",
    ingredients:
      "سكر - زيوت نباتية مهدرجة - دقيق القمح - جلوكوز - بودرة الكاكاو - كتلة الكاكاو - حليب خالي الدسم - حليب كامل الدسم - مصل الحليب - ديكستروز - ليستين الصويا E322 (مستحلب) - مواد رافعة (بيروفوسفات الصوديوم E450-1 - بيكربونات الأمونيوم - بيكربونات الصوديوم) - ملح الطعام - منكهات مماثلة للطبيعة.",
    weight: "30 غرام",
    packing: "12 علبة / طرد",
    box: "12 قطعة / علبة",
  },

  //Bisco Moosh
  {
    Images: [
      "/images/Product6/BiscoMooshEaten.webp",
      "/images/Product6/BiscoMoosh1.webp",
      "/images/Product6/BiscoMoosh2.webp",
      "/images/Product6/BiscoMoosh3.webp",
    ],
    title: "Bisco Moosh",
    description: "بسكويت محشي بالمارشميللو المغطس بالشوكولا",
    ingredients:
      "سكر - زيوت نباتية مهدرجة – دقيق الطحين – جلوكوز – كاكاو طبيعي – كتلة الكاكاو – حليب خالي الدسم – حليب كامل الدسم – مصل الحليب – سوربيتول E420 – جيلاتين بقري – ليستين الصويا E322 (مستحلب) – غلسرين – مواد رافعة (بيروفوسفات الصوديوم ، بيكربونات الأمونيوم) – مواد حافظة (سوربات البوتاسيوم E202) – ملح الطعام – منكهات مماثلة للطبيعة.",
    weight: "30 غرام",
    packing: "12 علبة / طرد",
    box: "12 قطعة / علبة",
  },
  //Biscojell Orange
  {
    Images: [
      "/images/Product7/BiscojellOrangeEaten.webp",
      "/images/Product7/BiscojellOrange1.webp",
      "/images/Product7/BiscojellOrange2.webp",
      "/images/Product7/BiscojellOrange3.webp",
    ],
    title: "Bisco Jell Orange",
    description: "بسكويت مع جيلي البرتقال",
    ingredients:
      "سكر , زيوت نباتية مهدرجة بالكامل , ماء , دقيق القمح , جلكوز , حليب خالي من الدسم , سوربيتول , بكتين , ليستين الصويا E322 , بيكربونات الصوديوم , ملح الطعام , فانيليا , سوربات البوتاسيوم , حمض الليمون , بيكربونات الامونيوم , منكهات (مماثلة للطبيعة) , ملونات طبيعية - E122 - E110 , جيلاتين بقري",
    weight: "22 غرام",
    packing: "6 علبة / طرد",
    box: "24 قطعة / علبة",
  },
  //Biscojell Berry
  {
    Images: [
      "/images/Product8/BiscojellBerryEaten.webp",
      "/images/Product8/BiscojellBerry1.webp",
      "/images/Product8/BiscojellBerry2.webp",
      "/images/Product8/BiscojellBerry3.webp",
    ],
    title: "Bisco Jell Berry",
    description: " بسكويت مع جيلي التوت المشكل",
    ingredients:
      "سكر , زيوت نباتية مهدرجة بالكامل , ماء , دقيق القمح , جلكوز , حليب خالي من الدسم , سوربيتول , بكتين , ليستين الصويا E322 , بيكربونات الصوديوم , ملح الطعام , فانيليا , سوربات البوتاسيوم , حمض الليمون , بيكربونات الامونيوم , منكهات (مماثلة للطبيعة) , ملونات طبيعية - E133 , جيلاتين بقري",

    weight: "22 غرام",
    packing: "6 علبة / طرد",
    box: "24 قطعة / علبة",
  },
  //Biscojell Strawberry
  {
    Images: [
      "/images/Product9/BiscojellStrawberryEaten.webp",
      "/images/Product9/BiscojellStrawberry1.webp",
      "/images/Product9/BiscojellStrawberry2.webp",
      "/images/Product9/BiscojellStrawberry3.webp",
    ],
    title: "Bisco Jell Strawberry",
    description: " بسكويت مع جيلي الفريز ",
    ingredients:
      "سكر , زيوت نباتية مهدرجة بالكامل , ماء , دقيق القمح , جلكوز , حليب خالي من الدسم , سوربيتول , بكتين , ليستين الصويا E322 , بيكربونات الصوديوم , ملح الطعام , فانيليا , سوربات البوتاسيوم , حمض الليمون , بيكربونات الامونيوم , منكهات (مماثلة للطبيعة) , ملونات طبيعية - E122 , جيلاتين بقري",

    weight: "22 غرام",
    packing: "6 علبة / طرد",
    box: "24 قطعة / علبة",
  },
  //Biscojell Apricot
  {
    Images: [
      "/images/Product10/BiscojellApricotEaten.webp",
      "/images/Product10/BiscojellApricot1.webp",
      "/images/Product10/BiscojellApricot2.webp",
      "/images/Product10/BiscojellApricot3.webp",
    ],
    title: "Bisco Jell Apricot",
    description: " بسكويت مع جيلي المشمش ",
    ingredients:
      "سكر , زيوت نباتية مهدرجة بالكامل , ماء , دقيق القمح , جلكوز , حليب خالي من الدسم , سوربيتول , بكتين , ليستين الصويا E322 , بيكربونات الصوديوم , ملح الطعام , فانيليا , سوربات البوتاسيوم , حمض الليمون , بيكربونات الامونيوم , منكهات (مماثلة للطبيعة) , ملونات طبيعية - E122 - E110 , جيلاتين بقري",
    weight: "22 غرام",
    packing: "6 علبة / طرد",
    box: "24 قطعة / علبة",
  },
  //Bisco Max Orange
  {
    Images: [
      "/images/Product11/BiscoMaxOrangeEaten.webp",
      "/images/Product11/BiscoMaxOrange1.webp",
      "/images/Product11/BiscoMaxOrange2.webp",
      "/images/Product11/BiscoMaxOrange3.webp",
    ],
    title: "Bisco Max Orange",
    description: " بسكويت الحليب محشي بكريم البرتقال ",
    ingredients:
      "سكر , زيوت نباتية مهدرجة بالكامل , دقيق القمح , جلوكوز , حليب خالي الدسم , حليب كامل الدسم , مصل الحليب , مستحلب ليستين الصويا E322 , مواد رافعة (بيروفوسفات الصوديوم E450-1 , بيكربونات الصوديوم , بيكربونات الأمونيوم) , ملح الطعام , منكهات - ملون غذائي E110",
    weight: "24 غرام",
    packing: "6 علبة / طرد",
    box: "24 قطعة / علبة",
  },
  //Bisco Max Choco
  {
    Images: [
      "/images/Product12/BiscoMaxChocoEaten.webp",
      "/images/Product12/BiscoMaxChoco1.webp",
      "/images/Product12/BiscoMaxChoco2.webp",
      "/images/Product12/BiscoMaxChoco3.webp",
    ],
    title: "Bisco Max Choco",
    description: " بسكويت الكاكاو محشي بكريم الحليب ",
    ingredients:
      "سكر , زيوت نباتية مهدرجة بالكامل , دقيق القمح , جلوكوز , كاكاو طبيعي , حليب خالي الدسم , حليب كامل الدسم , مصل الحليب , مستحلب ليستين الصويا E322 , مواد رافعة (بيروفوسفات الصوديوم E450-1 , بيكربونات الصوديوم , بيكربونات الأمونيوم) , ملح الطعام , منكهات",
    weight: "24 غرام",
    packing: "6 علبة / طرد",
    box: "24 قطعة / علبة",
  },
  //Bisco Max Choco Cream
  {
    Images: [
      "/images/Product13/BiscoMaxChocoCreamEaten.webp",
      "/images/Product13/BiscoMaxChocoCream1.webp",
      "/images/Product13/BiscoMaxChocoCream2.webp",
      "/images/Product13/BiscoMaxChocoCream3.webp",
    ],
    title: "Bisco Max Choco Cream",
    description: " بسكويت الحليب محشي بكريم الشوكولا ",
    ingredients:
      "سكر , زيوت نباتية مهدرجة بالكامل , دقيق القمح , جلوكوز , كاكاو طبيعي , حليب خالي الدسم , حليب كامل الدسم , مصل الحليب , مستحلب ليستين الصويا E322 , مواد رافعة (بيروفوسفات الصوديوم E450-1 , بيكربونات الصوديوم , بيكربونات الأمونيوم) , ملح الطعام , منكهات",
    weight: "24 غرام",
    packing: "6 علبة / طرد",
    box: "24 قطعة / علبة",
  },
  //Bisco Max Cocoa Biscuit
  {
    Images: [
      "/images/Product14/BiscoMaxCocoaBiscuitEaten.webp",
      "/images/Product14/BiscoMaxCocoaBiscuit1.webp",
      "/images/Product14/BiscoMaxCocoaBiscuit2.webp",
      "/images/Product14/BiscoMaxCocoaBiscuit3.webp",
    ],
    title: "Bisco Max Cocoa Biscuit",
    description: " بسكويت الكاكاو محشي بكريم الحليب ",
    ingredients:
      "سكر , زيوت نباتية مهدرجة بالكامل , دقيق القمح , جلوكوز , كاكاو طبيعي , حليب خالي الدسم , حليب كامل الدسم , مصل الحليب , مستحلب ليستين الصويا E322 , مواد رافعة (بيروفوسفات الصوديوم E450-1 , بيكربونات الصوديوم , بيكربونات الأمونيوم) , ملح الطعام , منكهات",
    weight: "24 غرام",
    packing: "6 علبة / طرد",
    box: "24 قطعة / علبة",
  },
  //Bisco Max Choco Biscuit
  {
    Images: [
      "/images/Product15/BiscoMaxChocoBiscuitEaten.webp",
      "/images/Product15/BiscoMaxChocoBiscuit1.webp",
      "/images/Product15/BiscoMaxChocoBiscuit2.webp",
      "/images/Product15/BiscoMaxChocoBiscuit3.webp",
    ],
    title: "Bisco Max Choco Biscuit",
    description: " بسكويت الكاكاو محشي بكريم الشوكولا ",
    ingredients:
      "سكر , زيوت نباتية مهدرجة بالكامل , دقيق القمح , جلوكوز , كاكاو طبيعي , حليب خالي الدسم , حليب كامل الدسم , مصل الحليب , مستحلب ليستين الصويا E322 , مواد رافعة (بيروفوسفات الصوديوم E450-1 , بيكربونات الصوديوم , بيكربونات الأمونيوم) , ملح الطعام , منكهات",
    weight: "24 غرام",
    packing: "6 علبة / طرد",
    box: "24 قطعة / علبة",
  },
  //BiscoMaxStrawberryCream
  {
    Images: [
      "/images/Product16/BiscoMaxStrawberryCreamEaten.webp",
      "/images/Product16/BiscoMaxStrawberryCream1.webp",
      "/images/Product16/BiscoMaxStrawberryCream2.webp",
      "/images/Product16/BiscoMaxStrawberryCream3.webp",
    ],
    title: "Bisco Max Strawberry Cream",
    description: " بسكويت الحليب محشي بكريم الفريز ",
    ingredients:
      "سكر , زيوت نباتية مهدرجة بالكامل , دقيق القمح , جلوكوز , كاكاو طبيعي , حليب خالي الدسم , حليب كامل الدسم , مصل الحليب , مستحلب ليستين الصويا E322 , مواد رافعة (بيروفوسفات الصوديوم E450-1 , بيكربونات الصوديوم , بيكربونات الأمونيوم) , ملح الطعام , منكهات , ملون غذائي E122",
    weight: "24 غرام",
    packing: "6 علبة / طرد",
    box: "24 قطعة / علبة",
  },
  //BiscoMaxCoffee
  {
    Images: [
      "/images/Product17/BiscoMaxCoffeeEaten.webp",
      "/images/Product17/BiscoMaxCoffee1.webp",
      "/images/Product17/BiscoMaxCoffee2.webp",
      "/images/Product17/BiscoMaxCoffee3.webp",
    ],
    title: "Bisco Max Coffee",
    description: " بسكويت القهوة محشي بكريم القهوة ",
    ingredients:
      "سكر , زيوت نباتية مهدرجة بالكامل , دقيق القمح , جلوكوز , كاكاو طبيعي , حليب خالي الدسم , حليب كامل الدسم , مصل الحليب , مستحلب ليستين الصويا E322 , مواد رافعة (بيروفوسفات الصوديوم E450-1 , بيكربونات الصوديوم , بيكربونات الأمونيوم) , ملح الطعام , منكهات",
    weight: "24 غرام",
    packing: "6 علبة / طرد",
    box: "24 قطعة / علبة",
  },
  //BiscoMaxCaramel
  {
    Images: [
      "/images/Product18/BiscoMaxCaramelEaten.webp",
      "/images/Product18/BiscoMaxCaramel1.webp",
      "/images/Product18/BiscoMaxCaramel2.webp",
      "/images/Product18/BiscoMaxCaramel3.webp",
    ],
    title: "Bisco Max Caramel",
    description: " بسكويت الكراميل محشي بكريم الكراميل ",
    ingredients:
      "سكر , زيوت نباتية مهدرجة بالكامل , دقيق القمح , جلوكوز , حليب خالي الدسم , حليب كامل الدسم , مصل الحليب , مستحلب ليستين الصويا E322 , مواد رافعة (بيروفوسفات الصوديوم E450-1 , بيكربونات الصوديوم , بيكربونات الأمونيوم) , ملح الطعام , منكهات",
    weight: "24 غرام",
    packing: "6 علبة / طرد",
    box: "24 قطعة / علبة",
  },
  //HuggyPuff
  {
    Images: [
      "/images/Product19/HuggyPuffEaten.webp",
      "/images/Product19/HuggyPuff1.webp",
      "/images/Product19/HuggyPuff2.webp",
      "/images/Product19/HuggyPuff3.webp",
    ],
    title: "Hugy Puff",
    description: " بسكويت مع المارشميلو مغطى بالفارماسيل ",
    ingredients:
      "سكر , زيوت نباتية مهدرجة بالكامل , دقيق الطحين , جلكوز , حليب خالي الدسم بودرة , مصل الحليب , سوربيتول E420 , جيلاتين بقري , ليستين الصويا (مستحلب E322) , غليسرين , مواد رافعة (بيروفوسفات الصوديوم E450-1 , بيكربونات الصوديوم , بيكربونات الامونيوم) , مواد حافظة (سوربات البوتاسيوم E202) , ملح الطعام , منكهات مماثلة للطبيعة , مونوغلسرايد",
    weight: "20 غرام",
    packing: "12 علبة / طرد",
    box: "12 قطعة / علبة",
  },
];
